// extracted by mini-css-extract-plugin
export default {"coursesCardsGrid":"coursesCards_coursesCardsGrid__yw1di"};